import { createAction } from 'redux-actions';
export const SET_SELECTED_SEGMENT_ID = 'SEAT_MAP/SET_SELECTED_SEGMENT_ID';
export const SET_NEXT_SEGMENT_ID = 'SEAT_MAP/SET_NEXT_SEGMENT_ID';
export const setSelectedSegmentId = createAction(SET_SELECTED_SEGMENT_ID);
export const setNextSegmentId = createAction(SET_NEXT_SEGMENT_ID);
